export default "__VITE_ASSET__DAFlHzwC__"